export default "__VITE_ASSET__5t4epEGW__"